var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickOutside,
          expression: "clickOutside",
        },
      ],
      class: ["v-dropdown", _vm.sizeClass],
    },
    [
      _c("dt", { staticClass: "v-dropdown-dt" }, [
        _c(
          "a",
          {
            class: [_vm.isSelect ? "v-dropdown-selected" : ""],
            style: { width: _vm.width + "px" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.toggleItems()
              },
            },
          },
          [_vm._t("default")],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "dd",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "v-dropdown-dd",
        },
        [
          _c(
            "ul",
            {
              staticClass: "v-dropdown-items",
              style: {
                "min-width": _vm.width + "px",
                "max-width": _vm.getMaxWidth + "px",
              },
            },
            [
              _vm.isMultiple
                ? [
                    _c(
                      "v-checkbox-group",
                      {
                        attrs: {
                          "is-vertical-show": "",
                          min: _vm.min,
                          max: _vm.max,
                        },
                        on: { change: _vm.checkboxGroupChange },
                        model: {
                          value: _vm.checkboxGroupList,
                          callback: function ($$v) {
                            _vm.checkboxGroupList = $$v
                          },
                          expression: "checkboxGroupList",
                        },
                      },
                      _vm._l(_vm.internalOptions, function (item) {
                        return _c(
                          "li",
                          {
                            class: [
                              "v-dropdown-items-multiple",
                              _vm.getTextAlignClass(),
                            ],
                          },
                          [
                            _c("v-checkbox", {
                              key: item.label,
                              attrs: {
                                label: item.label,
                                showLine: item.showLine,
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                : _vm._l(_vm.internalOptions, function (item) {
                    return _c(
                      "li",
                      {
                        class: [
                          "v-dropdown-items-li",
                          item.selected ? "active" : "",
                        ],
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.selectOptionClick(item)
                          },
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            class: [
                              "v-dropdown-items-li-a",
                              _vm.getTextAlignClass(),
                            ],
                            attrs: { href: "javascript:void(0);" },
                          },
                          [_vm._v(_vm._s(item.label))]
                        ),
                      ]
                    )
                  }),
              _vm._v(" "),
              _vm.showOperation
                ? _c("li", { staticClass: "v-dropdown-operation" }, [
                    _c(
                      "a",
                      {
                        staticClass: "v-dropdown-operation-item",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.confirm.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("确认")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "v-dropdown-operation-item",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.rest.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }